import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const flags = {
  en: "🇬🇧",
  tr: "🇹🇷"
};

export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'tr' : 'en');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
    >
      <span className="text-lg">{flags[language]}</span>
      <span className="text-sm font-medium text-gray-700">
        {language === 'en' ? 'EN' : 'TR'}
      </span>
    </button>
  );
}